import { useState, useContext, useEffect } from 'react';
import { DataContext } from 'providers/data';

import Modals from 'components/views/Modals';
import { DecodeToken } from 'utils/decodeToken';
import Select from 'components/views/form/Select';

import { Box, Typography, TextField } from '@mui/material';

import { ButtonRectangle } from 'components/views/form/Button';

const dataTopic = [
    {
        text: 'Vendas',
        value: '1'
    },
    {
        text: 'Boleto Bancário',
        value: '2'
    },
    {
        text: 'Troca de plano ou Veículo',
        value: '3'
    },
    {
        text: 'Assistência Técnica',
        value: '4'
    },
    {
        text: 'Devolução de equipamento',
        value: '5'
    },
    {
        text: 'Frotas',
        value: '6'
    },
    {
        text: 'Fale Com o Presidente',
        value: '7'
    },
    {
        text: 'Encarregado de Dados Pessoais (DPO)',
        value: '8'
    },
    {
        text: 'Demais informações',
        value: '9'
    },
    {
        text: 'Sugestão, elogio ou reclamação',
        value: '10'
    }
];

const FormEmail = () => {
    const { selectedCar, dataUserAccountPassword, dataFormFaleConosco, handlePostGetContacts, handlePostFormFaleConosco, handleClearSac } = useContext(DataContext);

    const [message, setMessage] = useState('');
    const [enableBtn, setEnableBtn] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState({ show: false, success: false });
    const [typeSelected, setTypeSelected] = useState({
        text: '',
        value: ''
    });

    const handlePostFormFaleConoscoState = () => {
        const tokenDetailsAux = DecodeToken();

        if (selectedCar && dataUserAccountPassword) {
            setIsLoading(true);

            handlePostFormFaleConosco({
                body: {
                    corporateNumberOrFisicalNumber: selectedCar.NR_CNPJ_CPF,
                    email: selectedCar.EMAIL,
                    message: message,
                    name: selectedCar.NOME_CLIENTE,
                    organicSource: "direct",
                    phone: dataUserAccountPassword?.phoneDDD ? `(${dataUserAccountPassword.phoneDDD}) ${dataUserAccountPassword.phoneNumber}` : tokenDetailsAux.cellphone || tokenDetailsAux.phone,
                    source: "/atendimento/fale-conosco",
                    subject: typeSelected.text
                }
            });
        }
    }

    useEffect(() => {
        if (selectedCar && !dataUserAccountPassword) {
            handlePostGetContacts(selectedCar.NR_CNPJ_CPF);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCar, dataUserAccountPassword]);

    useEffect(() => {
        if ((message?.length > 24) && (message?.length < 2001) && typeSelected.text) {
            setEnableBtn(false);
        } else {
            setEnableBtn(true);
        }
    }, [message, typeSelected]);

    useEffect(() => {
        if (dataFormFaleConosco !== undefined) {
            setIsLoading(false);
            handleClearSac();
            if (dataFormFaleConosco) {
                setShowModal({ show: true, success: true });
            } else {
                setShowModal({ show: true, success: false });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataFormFaleConosco]);

    return (
        <Box sx={{ padding: '1.8125rem 0 2.06rem', backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography sx={{ fontSize: '.9375rem', fontWeight: 600, paddingBottom: '1.5625rem', textAlign: 'center', lineHeight: '18px' }}>
                Envie sua dúvida criando uma solicitação e receba <br />
                sua resposta em até 72 horas no seu e-mail.
            </Typography>

            <Box sx={{ width: '100%', maxWidth: '23rem', 'button': { height: '2.5rem', width: '14rem' } }}>
                <Select
                    label='Assunto'
                    listItems={dataTopic}
                    itemSelected={typeSelected}
                    onChangeSelected={(e) => setTypeSelected(e)}
                    placeholder='Faça sua escolha'
                />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', margin: '1.3125rem 0 .3rem' }}>
                    <Typography sx={{ fontSize: '.75rem' }}>
                        Mensagem
                    </Typography>
                    <Typography sx={{ fontSize: '.75rem', color: `${message?.length > 2000 ? 'error.main' : 'grey.400'}` }}>
                        {message?.length} caracteres (min. 25 e máx. 2000)
                    </Typography>
                </Box>
                <TextField
                    placeholder="Digite sua mensagem"
                    multiline
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={9}
                    sx={{
                        width: '100%',
                        borderRadius: '9px',
                        border: '1.5px solid #8D9BB5',
                        marginBottom: '1.5625rem'
                    }}
                />
                <ButtonRectangle name='ENVIAR MENSAGEM' loadingBtn={isLoading} disabled={enableBtn} onClick={() => handlePostFormFaleConoscoState()} />
            </Box>

            <Modals open={showModal.show}>
                <Box sx={{ borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '23rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0', padding: '2.125rem 26px .8125rem', textAlign: 'center', maxWidth: '23rem' }}>
                        <Typography sx={{ fontSize: '1.5625rem', fontWeight: 700, paddingBottom: '.5rem' }}>
                            {showModal.success ? 'Mensagem enviada!' : 'ATENÇÃO!'}
                        </Typography>
                        <Typography sx={{ fontSize: '.875rem', fontWeight: 600, lineHeight: '17px' }}>
                            {showModal.success ?
                                'Em até 72 horas receba no seu e-mail a sua dúvida respondida.' :
                                'Não foi possivel enviar a mensagem.'
                            }
                        </Typography>
                    </Box>
                    <Box sx={{ borderRadius: '0 0 8px 8px', padding: '2.1875rem 3.75rem 1.875rem', backgroundColor: 'primary.main', 'button': { width: '100%' } }}>
                        <ButtonRectangle
                            name={`${showModal.success ? 'CONTINUAR' : 'FECHAR'}`}
                            onClick={() => {
                                setShowModal({ show: false, success: false });
                                setTypeSelected({ text: '', value: '' });
                                setMessage('')
                            }
                            } />
                    </Box>
                </Box>
            </Modals>
        </Box>
    );
}

export default FormEmail;